import { gql } from '@apollo/client';

const LIST_TEXT_TOOLTIPS = gql`
  query LIST_TEXT_TOOLTIPS($projectId: String!) {
    textTooltip {
      list(projectId: $projectId){
        edges {
          node {
            description
            id
            title
          }
        }
      }
    }
  }
`;

export { LIST_TEXT_TOOLTIPS };
